module.exports = {
	"all_scored": 5174
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersAllScored.json
// module id = 964
// module chunks = 0